import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  position: absolute;
  z-index: 2;
  top: -170px;

  img {
    display: block;
    height: 170px;
    object-fit: cover;
    width: 100%;
  }
`;
